import { render } from "./About.vue?vue&type=template&id=0be45126&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=0be45126&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0be45126"

export default script